"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskViewQueryParams = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../__generated__/graphql");
const react_redux_1 = require("react-redux");
const view_query_params_1 = require("../../../common/view-query-params");
const query_params_1 = require("../../../hooks/query-params");
const actions_1 = require("../../../store/catalogs/task-view/actions");
const hooks_1 = require("../../../strategy-matrix/client/hooks");
const hooks_2 = require("../../../../hooks");
const store_1 = require("../../../../store");
const useTaskViewQueryParams = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { addError } = (0, hooks_2.useNotification)();
    const { encodedViewQueryState } = (0, view_query_params_1.useViewQueryStateQueryParam)();
    const searchParams = (0, query_params_1.useQueryParams)();
    const { attributeName, terminalNodeId } = searchParams;
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    (0, react_1.useLayoutEffect)(() => {
        if (!selectedCatalogId || !terminalNodeId || !attributeName || encodedViewQueryState)
            return;
        dispatch((0, actions_1.resetTaskViewTable)(selectedCatalogId));
    }, [attributeName, dispatch, encodedViewQueryState, selectedCatalogId, terminalNodeId]);
    // Load tree node's ancestors to properly build selected node path and set it in redux
    const { data: ancestors, error, isLoading: areAncestorsLoading, isTerminal, } = (0, hooks_1.useGetNodeRelations)({
        productTreeNodeId: terminalNodeId,
        sort: [{ distance: graphql_1.SortOrder.Asc }],
    });
    (0, react_1.useEffect)(() => {
        if (selectedCatalogId && (ancestors === null || ancestors === void 0 ? void 0 : ancestors.length) && terminalNodeId) {
            if (!isTerminal) {
                addError('Please select a terminal node.');
            }
            else {
                const pathIds = ancestors.map((edge) => edge.node.ancestor.id).join(store_1.STRATEGY_NODE_PATH_SEPARATOR);
                dispatch((0, actions_1.setTaskViewSelectedTreeNodePath)(selectedCatalogId, pathIds));
            }
        }
    }, [ancestors, dispatch, selectedCatalogId, terminalNodeId, isTerminal, addError]);
    return {
        searchParams,
        isLoading: areAncestorsLoading,
        error,
    };
};
exports.useTaskViewQueryParams = useTaskViewQueryParams;
